import AWS from "aws-sdk";

import {
  awsID,
  awsBucketName,
  awsSECRET,
} from "../pages/utilities/axios-config";

const s3 = new AWS.S3({
  accessKeyId: awsID,
  secretAccessKey: awsSECRET,
});

export const uploadMultipleFiles = async (files) => {
  const filePromises = files.map((file) => {
    const fileName = new Date().getTime() + "_" + file.name;
    const params = {
      Bucket: awsBucketName,
      Key: fileName,
      Body: file,
      ContentType: file.type,
    };
    return s3.upload(params).promise();
  });
  return Promise.all(filePromises);
};

export const uploadSingleFile = async (file) => {
  const fileName = new Date().getTime() + "_" + file.name;
  const params = {
    Bucket: awsBucketName,
    Key: fileName,
    Body: file,
    ContentType: file.type,
  };
  return s3.upload(params).promise();
};

export const deleteFile = async (key) => {
  const params = {
    Bucket: awsBucketName,
    Key: key,
  };
  return s3.deleteObject(params).promise();
};
